import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Single source of truth for GTM dataLayer pushes. No gtag.js — GTM only.
export function pushDataLayer(payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

// Fires a dataLayer event once per real navigation to the page (keyed by React
// Router location.key). Re-renders and StrictMode double-mounts share the same
// location.key, so the event is never duplicated; a genuine new navigation gets
// a fresh key and fires once again.
export function usePageEvent(payload) {
  const location = useLocation();
  useEffect(() => {
    const fired = (window.__dukkEventsFired = window.__dukkEventsFired || {});
    const key = `${payload.event}@${location.key}`;
    if (fired[key]) return;
    fired[key] = true;
    pushDataLayer(payload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);
}
